import { render } from "./sub-categories-list.vue?vue&type=template&id=004a7921"
import script from "./sub-categories-list.vue?vue&type=script&lang=js"
export * from "./sub-categories-list.vue?vue&type=script&lang=js"

import "./sub-categories-list.vue?vue&type=style&index=0&id=004a7921&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__